import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: {
    invite: {},
    inviteMap: {},
    inviteDetail: {},
    stat: {}
  },
  mutations: {
    /** 队长邀请排行榜 */
    initInvite: function initInvite(state, _a) {
      var key = _a.key;
      Vue.set(state.invite, key, {
        list: [],
        loaded: false,
        requesting: false
      });
    },
    concatInvite: function concatInvite(state, _a) {
      var key = _a.key,
          list = _a.list;
      var ids = [];
      (list || []).forEach(function (item) {
        if (item && item.id) {
          Vue.set(state.inviteMap, item.id, item);
          ids.push(item.id);
        }
      });
      state.invite[key].list = state.invite[key].list.concat(ids);
    },
    setInviteLoaded: function setInviteLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.invite[key].loaded = loaded;
    },
    setInviteReq: function setInviteReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.invite[key].requesting = req;
    },
    setStat: function setStat(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.stat, activityId, data);
    },
    setInviteDetail: function setInviteDetail(state, _a) {
      var teamId = _a.teamId,
          detail = _a.detail;
      Vue.set(state.inviteDetail, teamId, detail);
    }
  },
  actions: {
    /**
     * 邀请队伍
     */
    getInvite: function getInvite(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          nav = _b.nav,
          offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, len, params, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = activityId + "_" + nav;
              wrap = state.invite[key];

              if (!wrap || offset === 0 && forceUpdate) {
                commit('initInvite', {
                  key: key
                });
                wrap = state.invite[key];
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              params = {
                offset: offset,
                count: count,
                activity_id: activityId,
                is_history: nav === 'history' ? 1 : 0
              };
              commit('setInviteReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/team/invite_team_list', {
                params: params
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatInvite', {
                  key: key,
                  list: list
                });

                if (list.length < count) {
                  commit('setInviteLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setInviteReq', {
                key: key,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取邀请的新队长带来的新队员数
     */
    getInvitNew: function getInvitNew(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/team/invite_new', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setStat', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得邀请列表
     */
    getInvitDetail: function getInvitDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              commit('setListReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/team/invite_team_detail', {
                params: {
                  id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setInviteDetail', {
                  teamId: teamId,
                  detail: rdata.data
                });
              }

              commit('setListReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;